import { render, staticRenderFns } from "./news-grid.vue?vue&type=template&id=68619faa"
import script from "./news-grid.vue?vue&type=script&lang=js"
export * from "./news-grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports